import React, { useEffect, useState } from 'react'
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap'
import SecBTN from '../../UI/SecBTN'
import Input from '../../UI/Input/Input'
import Graybg from '../../UI/Graybg'
import classes from '../BulkQuestionRequest/style.module.css';
import Card from '../../UI/Card/Card';
import './Exercisedpp.module.css';
import userService from '../../app/services/user.service'
import VideoSolutionLink from './VideoSolutionLink'
import UploadExercise from './UploadExercise'
import UploadSolution from './UploadSolution'
import VideoSolutionList from './VideoSolutionList'
import Dpp from './Dpp'
import Exercise from './Exercise'

export const ExerciseDPP = () => {
  // Panel buttons activity
  const navBtn = [
    "Exercise",
    "Dpp",
    "Video Solution List",
    "Video Solution Link",
    "Upload Excercise/DPP",
    "Upload Video Solution"
  ];
  const [navBtnActive, setNavBtnActive] = useState(navBtn[0]);
  const [subjectList,setSubjectList] =useState([]);
  const downloadFile = () => {
    console.log(window.location.origin)
    fetch(window.location.origin+"/files/jeemains.xlsx").then((response) => {
      response.blob().then((blob) => {
       
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "jeemains.xlsx";
          alink.click();
      });
  });
  }

  const fetchSubjectList = () => {
    userService.getSubjectList()
    .then((res) => {
      setSubjectList(res.data.data);
    })
    .catch(err => {
      console.error(err);
    })
  }

  useEffect(() => {
    fetchSubjectList();
  },[])
  return (
    <div className="section">
      <h4>Exercise/DPP List</h4>
      <Breadcrumb>
        <Breadcrumb.Item>Exercise/DPP List</Breadcrumb.Item>
        <Breadcrumb.Item active>{navBtnActive}</Breadcrumb.Item>
      </Breadcrumb>
      <Graybg>
      <div className={`mb-4 ${classes.navPanel}`}>
          {navBtn.map((navItem) => {
            return (
              <button
                key={navItem}
                className={
                  navItem === navBtnActive
                    ? classes.navItemActive
                    : classes.navItem
                }
                onClick={() => setNavBtnActive(navItem)}
              >
                {navItem}
              </button>
            );
          })}
        </div>
        <Card className={classes.card}>
         {navBtnActive === navBtn[0]  && <Exercise />}
         {navBtnActive === navBtn[1]  && <Dpp/>}
         {navBtnActive === navBtn[2]  && <VideoSolutionList />}
         {navBtnActive === navBtn[3]  && <VideoSolutionLink/>}
         {navBtnActive === navBtn[4]  && <UploadExercise/>}
         {navBtnActive === navBtn[5]  && <UploadSolution/>}
        </Card>
        
      </Graybg>
    </div>
  )
}

